import React from 'react';
import { Search } from 'lucide-react';
import { Input } from '@/components/ui/FormComponents';

export const MaterialSearchField = ({
  searchTerm,
  onSearchChange,
  placeholder = 'Search by item name or category...',
  inputId = 'material-search-input',
  className = ''
}) => {
  return (
    <div className={`relative w-full ${className}`}>
      <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400 pointer-events-none z-10" />
      {/* Polinaidu: 24-04-2026 (20:08) - Using reusable Input component while maintaining original styling */}
      <Input
        type="text"
        placeholder={placeholder}
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        className="pl-11 pr-4 py-2.5 bg-white border-slate-200 shadow-sm shadow-slate-200/50"
        id={inputId}
        autoComplete="off"
      />
    </div>
  );
};
